import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SitePagesService } from 'src/app/shared/api/site-pages.service';
import { CultureService } from 'src/app/shared/culture/culture.service';

/// The two seller forms on the public pages (PrimeCommerce_Seller_Content_Plan.md 10.7): the Dhaka Hub waitlist
/// (kind "dhaka-hub", /sell/dhaka-hub), the Enterprise enquiry (kind "enterprise", /primecommerce/pricing#enterprise-form) and
/// a seller's question from Talk to us (kind "seller-question", in TalkDialogComponent's pop-up, 2026-11-02).
/// It posts to SellerLeads/Send with the contact form's signed token (fetched in the browser only) and a field only
/// scripts fill; the server checks everything again and keeps the lead for the owner.
@Component({
    selector: 'app-lead-form',
    templateUrl: './lead-form.component.html',
    styleUrls: ['./lead-form.component.scss']
})
export class LeadFormComponent implements OnInit, OnDestroy {
    @Input() kind: 'dhaka-hub' | 'enterprise' | 'seller-question' = 'dhaka-hub';

    form: { [field: string]: string } = {
        name: '', phone: '', email: '', business: '', district: '', category: '', ordersPerMonth: '', products: '', message: '', website: '',
    };
    errors: { [field: string]: string } = {};
    state: 'idle' | 'sending' | 'sent' | 'failed' | 'too-many' = 'idle';

    private token: string | null = null;
    private destroy$ = new Subject<void>();

    constructor(private pages: SitePagesService, private culture: CultureService, @Inject(PLATFORM_ID) private platformId: any) { }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.fetchToken();
        }
    }

    get id(): string {
        return 'lead-' + this.kind;
    }

    submit(): void {
        if (this.state === 'sending') {
            return;
        }
        this.state = 'sending';
        this.errors = {};
        this.send(1);
    }

    private send(attempt: number): void {
        const body = { ...this.form, kind: this.kind, token: this.token || '', language: this.culture.lang === 'bn' ? 'bn' : 'en' };
        this.pages.sendLead(body).pipe(takeUntil(this.destroy$)).subscribe(answer => {
            const result = answer && answer.result;
            if (result === 'sent') {
                this.state = 'sent';
            } else if (result === 'invalid') {
                this.errors = (answer && answer.errors) || {};
                this.state = 'idle';
            } else if (result === 'retry' && attempt < 3) {
                // A token too fresh waits the seconds the server names; a stale one (a deploy) is fetched again.
                const wait = Math.max(0, (answer.wait || 0) * 1000);
                setTimeout(() => this.fetchToken(() => this.send(attempt + 1)), wait);
            } else if (result === 'too-many') {
                this.state = 'too-many';
            } else {
                this.state = 'failed';
            }
        }, () => this.state = 'failed');
    }

    private fetchToken(then?: () => void): void {
        this.pages.formToken().pipe(takeUntil(this.destroy$)).subscribe(token => {
            this.token = token;
            if (then) {
                then();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
